import { render, staticRenderFns } from "./CustomerAssignmentTable.vue?vue&type=template&id=19646a6a"
import script from "./CustomerAssignmentTable.vue?vue&type=script&lang=js"
export * from "./CustomerAssignmentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports